import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { IS_MAC } from './keyboard-shortcuts';

interface ShortcutRow {
  label: string;
  keys: string[];
}

interface ShortcutSection {
  title: string;
  rows: ShortcutRow[];
}

/** Lists the app's keyboard shortcuts (opened from the help button or the command palette). */
@Component({
  selector: 'app-keyboard-shortcuts-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule, TranslateModule],
  templateUrl: './keyboard-shortcuts-dialog.component.html',
  styleUrl: './keyboard-shortcuts-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeyboardShortcutsDialogComponent {
  @Input() visible = false;

  @Output() visibleChange = new EventEmitter<boolean>();

  readonly sections: ShortcutSection[] = buildShortcutSections(IS_MAC);

  trackByLabel(_: number, item: { label?: string; title?: string }): string {
    return item.label ?? item.title ?? '';
  }
}

/** Ctrl on Windows/Linux, ⌘ on macOS. */
export function buildShortcutSections(mac: boolean): ShortcutSection[] {
  const mod = mac ? '⌘' : 'Ctrl';
  return [
    {
      title: 'keyboardShortcuts.general',
      rows: [
        { label: 'keyboardShortcuts.commandPalette', keys: [mod, 'K'] },
        { label: 'keyboardShortcuts.toggleSidebar', keys: [mod, 'B'] },
        { label: 'keyboardShortcuts.toggleSections', keys: [mod, 'I'] },
      ],
    },
    {
      title: 'keyboardShortcuts.inPalette',
      rows: [
        { label: 'keyboardShortcuts.navigate', keys: ['↑', '↓'] },
        { label: 'keyboardShortcuts.select', keys: ['↵'] },
        { label: 'keyboardShortcuts.close', keys: ['Esc'] },
      ],
    },
  ];
}
